import { VectorEditorStickerFreeCreatorPCF } from '../Function/module/VectorEditorStickerFreeCreatorPCF.js';

export const handleNewStickerButtonClick =
  ({ tab_el }) =>
  () =>
    VectorEditorStickerFreeCreatorPCF.addNewSticker({ tab_el });
